module.exports = __webpack_public_path__ + "img/JakeO.abf778ce.jpg";